import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';

const stats = [
  { value: '50000+', label: '电影资源' },
  { value: '1000万+', label: '月活用户' },
  { value: '99.9%', label: '播放成功率' },
  { value: '8年', label: '稳定运营' },
];

const reputations = [
  {
    name: '影迷小王',
    text: '6080影视真的太棒了！资源更新很快，画质也很清晰，完全不卡顿。自从发现了这个网站，我再也不用到处找资源了。',
  },
  {
    name: '电影爱好者阿明',
    text: '用了快两年了，体验一直很好。分类清晰，找片方便，最重要的是完全免费，强烈推荐给所有影迷朋友！',
  },
  {
    name: '追剧达人Lucy',
    text: '片库真的太全了，很多冷门经典老片都能找到。播放流畅度也很好，4K画质看着特别过瘾。每天都会来看看更新了什么新片。',
  },
];

const faqs = [
  {
    question: '6080影视收费吗？',
    answer: '完全免费！6080影视始终坚持免费提供高清电影在线观看服务，无需VIP会员，所有影片均可免费流畅观看。',
  },
  {
    question: '电影画质怎么样？',
    answer: '我们提供HD高清和4K超清两种画质选择。依托6080新视觉影视资源，大部分影片支持4K超清播放，画质清晰细腻。',
  },
  {
    question: '需要下载播放器吗？',
    answer: '不需要。6080影视采用先进的在线播放技术，直接在浏览器中即可流畅观看，无需下载任何播放器或插件。',
  },
  {
    question: '电影资源更新快吗？',
    answer: '非常快。我们拥有专业的内容运营团队，最新大片上映后第一时间更新，让您第一时间观看到最新热映影片。',
  },
  {
    question: '支持手机观看吗？',
    answer: '当然支持。6080影视采用响应式设计，完美适配电脑、平板和手机等各类设备，随时随地享受高清观影体验。',
  },
];

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <div className="pt-20 pb-8 bg-background-100 border-b border-background-300/40">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <Breadcrumb
                items={[
                  { label: '首页', path: '/' },
                  { label: '关于我们' },
                ]}
              />
              <h1 className="text-2xl md:text-4xl font-bold text-foreground-100 font-heading mt-2">
                关于6080影视
              </h1>
            </div>
          </div>
        </div>

        <section className="py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-5 mb-16">
                {stats.map((stat, index) => (
                  <div
                    key={index}
                    className="bg-background-100 border border-background-300/40 rounded-xl p-6 text-center hover:border-primary-500/30 transition-all duration-300"
                  >
                    <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading mb-2">
                      {stat.value}
                    </div>
                    <div className="text-sm text-foreground-500">
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>

              <div className="max-w-3xl mx-auto mb-16">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading mb-6 flex items-center gap-3">
                  <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm text-foreground-500 leading-relaxed">
                  <p>
                    6080影视创立于2018年，是国内领先的免费高清电影在线观看平台。我们依托6080新视觉影视强大的资源库，致力于为广大影迷提供最优质的在线观影体验。
                  </p>
                  <p>
                    平台汇聚了海量电影资源，涵盖动作、喜剧、科幻、爱情、恐怖、动画、剧情、战争、纪录片等多种类型，满足不同用户的观影需求。从经典老片到最新大片，一应俱全。每日更新最新影片资源，确保用户第一时间看到想看的电影。
                  </p>
                  <p>
                    我们拥有专业的视频技术团队和内容运营团队，采用全球CDN加速节点技术，确保每一部影片都能以最高画质、最流畅的方式呈现给用户。始终坚持以用户体验为核心，不断优化产品和服务，为全网影迷打造最佳的免费观影平台。
                  </p>
                </div>
              </div>

              <div className="max-w-3xl mx-auto mb-16">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading mb-6 flex items-center gap-3">
                  <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
                  用户口碑
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                  {reputations.map((rep, index) => (
                    <div
                      key={index}
                      className="bg-background-100 border border-background-300/40 rounded-xl p-6"
                    >
                      <div className="flex items-center gap-1 mb-3">
                        {[...Array(5)].map((_, i) => (
                          <div
                            key={i}
                            className="w-4 h-4 flex items-center justify-center"
                          >
                            <i className="ri-star-fill text-xs text-accent-500"></i>
                          </div>
                        ))}
                      </div>
                      <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                        "{rep.text}"
                      </p>
                      <p className="text-sm font-medium text-foreground-200 font-heading">
                        —— {rep.name}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="max-w-3xl mx-auto mb-16">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading mb-6 flex items-center gap-3">
                  <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
                  常见问题
                </h2>
                <div className="space-y-3">
                  {faqs.map((faq, index) => (
                    <details
                      key={index}
                      className="bg-background-100 border border-background-300/40 rounded-xl group"
                    >
                      <summary className="px-6 py-4 cursor-pointer flex items-center justify-between text-sm font-medium text-foreground-200 font-heading hover:text-primary-400 transition-colors list-none">
                        {faq.question}
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform"></i>
                        </div>
                      </summary>
                      <div className="px-6 pb-4 text-sm text-foreground-500 leading-relaxed">
                        {faq.answer}
                      </div>
                    </details>
                  ))}
                </div>
              </div>

              <div className="max-w-3xl mx-auto">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading mb-6 flex items-center gap-3">
                  <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
                  联系我们
                </h2>
                <div className="bg-background-100 border border-background-300/40 rounded-xl p-8">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400 shrink-0">
                        <i className="ri-mail-line text-lg"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-200 mb-1">电子邮箱</div>
                        <div className="text-sm text-foreground-500">service@6080ys.com</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10 text-accent-500 shrink-0">
                        <i className="ri-wechat-line text-lg"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-200 mb-1">微信公众号</div>
                        <div className="text-sm text-foreground-500">6080影视</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-500/10 text-secondary-400 shrink-0">
                        <i className="ri-qq-line text-lg"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-200 mb-1">QQ群</div>
                        <div className="text-sm text-foreground-500">873621540</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400 shrink-0">
                        <i className="ri-map-pin-line text-lg"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-200 mb-1">公司地址</div>
                        <div className="text-sm text-foreground-500">北京市朝阳区光华路SOHO 2期</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <ScrollToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于6080影视',
            description:
              '6080影视 - 免费高清电影在线观看平台品牌介绍、用户口碑与联系方式。',
            url: 'https://yunlv8888.cn/about',
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://yunlv8888.cn/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                },
              ],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </div>
  );
}